import { Box, BoxProps } from '@material-ui/core';
import React, { ReactNode } from 'react';

export const FlexBox = ({
  children,
  direction = 'row',
  ...restProps
}: {
  children: ReactNode;
  direction?: 'row' | 'column';
} & BoxProps) => (
  <Box
    {...restProps}
    sx={{
      display: 'flex',
      flexDirection: direction,
      justifyContent: 'center',
      alignItems: 'center',
      ...restProps.sx,
    }}
  >
    {children}
  </Box>
);
